import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AccessProvider, useAccess } from "./context/AccessContext";
import { CartProvider } from "./context/CartContext";
import ComingSoonPage from "./pages/ComingSoonPage";

// Pages
import EntryGate from "./pages/EntryGate";
import AccessPage from "./pages/AccessPage";
import MemberHome from "./pages/MemberHome";
import ProductPage from "./pages/ProductPage";
import Checkout from "./pages/Checkout";
import Confirmation from "./pages/Confirmation";
import CollectionPage from "./pages/CollectionPage";
import AboutPage from "./pages/AboutPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import AboutUsPage from "./pages/AboutUsPage";
import MembershipPage from "./pages/MembershipPage";
import LabPage from "./pages/LabPage";
import RewardsPage from "./pages/RewardsPage";
import JournalPage from "./pages/JournalPage";
import RitualGuidePage from "./pages/RitualGuidePage";
import NewDropsPage from "./pages/NewDropsPage";
import ShippingPage from "./pages/ShippingPage";
import ProfilePage from "./pages/ProfilePage";
import GiftPage from "./pages/GiftPage";
import LearnPage from "./pages/LearnPage";
import ArticlePage from "./pages/ArticlePage";

const ProtectedRoute = ({ children }) => {
  const { hasAccess, isLoading } = useAccess();
  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-white/20 border-t-white rounded-full animate-spin" />
      </div>
    );
  }
  if (!hasAccess) {
    return <Navigate to="/dev" replace />;
  }
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Coming Soon — public landing */}
      <Route path="/" element={<ComingSoonPage />} />

      {/* Dev preview — full site under /dev */}
      <Route path="/dev" element={<EntryGate />} />
      <Route path="/dev/access" element={<AccessPage />} />
      <Route path="/dev/collection" element={<ProtectedRoute><MemberHome /></ProtectedRoute>} />
      <Route path="/dev/collection/:category" element={<ProtectedRoute><CollectionPage /></ProtectedRoute>} />
      <Route path="/dev/product/:id" element={<ProtectedRoute><ProductPage /></ProtectedRoute>} />
      <Route path="/dev/about" element={<ProtectedRoute><AboutPage /></ProtectedRoute>} />
      <Route path="/dev/about-us" element={<ProtectedRoute><AboutUsPage /></ProtectedRoute>} />
      <Route path="/dev/faq" element={<ProtectedRoute><FAQPage /></ProtectedRoute>} />
      <Route path="/dev/contact" element={<ProtectedRoute><ContactPage /></ProtectedRoute>} />
      <Route path="/dev/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
      <Route path="/dev/confirmation" element={<ProtectedRoute><Confirmation /></ProtectedRoute>} />
      <Route path="/dev/membership" element={<ProtectedRoute><MembershipPage /></ProtectedRoute>} />
      <Route path="/dev/lab" element={<ProtectedRoute><LabPage /></ProtectedRoute>} />
      <Route path="/dev/rewards" element={<ProtectedRoute><RewardsPage /></ProtectedRoute>} />
      <Route path="/dev/journal" element={<ProtectedRoute><JournalPage /></ProtectedRoute>} />
      <Route path="/dev/rituals" element={<ProtectedRoute><RitualGuidePage /></ProtectedRoute>} />
      <Route path="/dev/new-drops" element={<ProtectedRoute><NewDropsPage /></ProtectedRoute>} />
      <Route path="/dev/shipping" element={<ProtectedRoute><ShippingPage /></ProtectedRoute>} />
      <Route path="/dev/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      <Route path="/dev/gift" element={<ProtectedRoute><GiftPage /></ProtectedRoute>} />
      <Route path="/dev/learn" element={<ProtectedRoute><LearnPage /></ProtectedRoute>} />
      <Route path="/dev/learn/:slug" element={<ProtectedRoute><ArticlePage /></ProtectedRoute>} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AccessProvider>
          <CartProvider>
            <AppRoutes />
          </CartProvider>
        </AccessProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
